import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Catalogs|Credential|Metadata|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ClientMetadata,
	portal: 'SP',
};

export type SPCertMetadataLocNames =
	| 'SPCertMetadataTitleSection'
	| 'SPCertMetadataButtonEdit'
	| 'SPCertMetadataButtonCancel'
	| 'SPCertMetadataButtonSave'
	| 'SPCertMetadataButtonSaveSuccess'
	| 'SPCertMetadataNoChanges'
	| 'SPCertMetadataNone';

export const spCertMetadataLocs: LocDefs<SPCertMetadataLocNames> = {
	SPCertMetadataTitleSection: {
		defaultValue: 'Metadata',
		description: 'Section title for credential metadata',
		displayPath: `${pathStart}Section title`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPCertMetadataButtonEdit: {
		defaultValue: 'Edit',
		description: 'Edit button / tooltip',
		displayPath: `${pathStart}Edit`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPCertMetadataButtonCancel: {
		defaultValue: 'Cancel',
		description: 'Cancel button / tooltip',
		displayPath: `${pathStart}Cancel`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPCertMetadataButtonSave: {
		defaultValue: 'Save',
		description: 'Save button / tooltip',
		displayPath: `${pathStart}Save`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPCertMetadataButtonSaveSuccess: {
		defaultValue: 'Changes Saved',
		description: 'Save success message',
		displayPath: `${pathStart}Save success`,
		displayType: 'Notification',
		...sharedProperties,
	},
	SPCertMetadataNoChanges: {
		defaultValue: 'You must make at least one change',
		description: 'Shown when saving without any changes',
		displayPath: `${pathStart}No changes`,
		displayType: 'Notification',
		...sharedProperties,
	},
	SPCertMetadataNone: {
		defaultValue: 'No metadata found.',
		description: 'Shown when the catalog has no metadata',
		displayPath: `${pathStart}None`,
		displayType: 'Content',
		...sharedProperties,
	},
};

export type SPCertMetadataLocType = LocMap<SPCertMetadataLocNames>;
